module.exports = __webpack_public_path__ + "static/ft01-425ac9f837ea23102731fc84f91ac4db.jpg";